import { apiDelete, apiGet, apiPost, apiPut } from '../../generic/Api_Functions'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { systemValueDescription, systemValueLabel, systemValueOptionText } from '../../generic/systemValues/systemValueLabel'
import { useAuthorization } from '../../generic/hooks/useAuthorization'

const OrderStatus = () => {
  const { t_ } = useSmartTranslation()
  const isUserAuthorized = useAuthorization()

  const columns = [
    {
      name: t_('Code'),
      field: 'code',
      unique: true,
      mandatory: true,
      readOnly: true,
      charLimit: 60
    },
    {
      name: t_('Name'),
      field: 'name',
      render: (row) => systemValueLabel(t_, 'order_status', row),
      renderOnlyInReadMode: true,
      unique: true,
      mandatory: true,
      charLimit: 80,
      readOnly: (row) => {
        return row.systemDefault
      }
    },
    {
      name: t_('Description'),
      field: 'description',
      charLimit: 200,
      // P10: a seeded row's description is factory text and reads translated; a customer row keeps its own.
      render: (row) => systemValueDescription(t_, 'order_status', row),
      renderOnlyInReadMode: true
    },
    {
      name: t_('Status type'),
      field: 'orderStatusType.name',
      render: (row) => systemValueLabel(t_, 'order_status_type', row.orderStatusType),
      renderOnlyInReadMode: true,
      filterByLabel: { options: (items) => items.map((item) => ({ value: item.name, label: systemValueLabel(t_, 'order_status_type', item) })) },
      type: 'smartSelect',
      edit: {
        source: async () => {
          return await apiGet('simpleOrderStatusTypes')
        },
        id: 'id',
        field: 'name',
        optionLabel: (name, items) => systemValueOptionText(t_, 'order_status_type', items, name)
      },
      readOnly: (row) => {
        return row.systemDefault
      },
      mandatory: true
    }
  ]

  const actions = {
    create: {
      fetchFunction: (row) => {
        return apiPost('orderStatus/create', row)
      },
      disabled: !isUserAuthorized('ADD_ORDER_STATUS')
    },
    edit: {
      fetchFunction: (row) => {
        return apiPut('orderStatus', row)
      },
      disabled: !isUserAuthorized('EDIT_ORDER_STATUS')
    },
    delete: {
      visibilityButton: row => !row.systemDefault,
      fetchFunction: (rows) => {
        if (rows.length === 1) {
          return apiDelete('orderStatus/' + rows[0].id)
        } else {
          return apiDelete('orderStatus/deleteMulti/', rows)
        }
      },
      disabled: !isUserAuthorized('DELETE_ORDER_STATUS')
    }
  }
  const getData = async (pagination) => {
    return await apiGet('orderStatus', pagination)
  }

  return (
    <SmartMateriaUITable
      tableTuneUniqueKey='orderStatus'
      columns={columns}
      title={t_('Order status')}
      dataFetch={getData}
      actions={actions}
      pageable
      multipleSelection
      safeDeleteShowProperty='name'
    />
  )
}

export default OrderStatus
